export const numericFont = 'Verdana, sans-serif';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/sharedStyle/font.ts